// Kontext pro výchozí obsah detail panelu (list-detail root)

import { createContext } from 'react';

/** Kontrakt mezi shellem (poskytuje cíl) a root agendou (dodává obsah). */
export interface DetailZoneOutletContextValue {
  /** DOM cíl pro výchozí obsah detail panelu; `null` mimo list-detail root. */
  readonly target: HTMLElement | null;
  /** Detail zónu drží vrstva → výchozí obsah je skrytý, ale ZŮSTÁVÁ připojený. */
  readonly covered: boolean;
}

export const DetailZoneOutletContext = createContext<DetailZoneOutletContextValue>({
  target: null,
  covered: false,
});
